<template>
  <div>
  <b-navbar id="navbar" type="dark" variant="info" >
    <b-navbar-nav>
      <b-nav-item href="#"><router-link v-bind:to="'/dashboard'">id verifier</router-link>
      </b-nav-item>
     
    </b-navbar-nav>
        
  </b-navbar>


</div>
</template>

<script>

export default {
  data(){
    return{
      
    }
  },
   computed:{
     user(){
       return this.$store.state.user.username;
     }
   },
   methods:{
    
   },
   mounted:function(){
    




   }
}
</script>

<style>
ul{
    list-style-type: none;
}

li{
  display: inline-block;
}
#logo{
  font-size: 25px;
}
#navbar{
  position: fixed;
  width: 100%;
  z-index: 98;
}
</style>
